import { AdminMessage } from "@components/admin/admin-helpers"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { SlideTimerIndicator } from "@components/atoms/SlideTimerIndicator"
import { LargeCard } from "@components/patterns/LargeCard"
import { Button } from "@components/ui/Button"
import { Chip, chipStyles } from "@components/ui/Chip"
import { useSlideTimer } from "@hooks/useSliderTimer"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Featured Guests Slider",
  icon: "admin-users",
  tags: ["#subpage-layout"],
  description: "Displays guests in a slider",
  flags: {
    fullWidth: true,
    marginRule: "long-card",
  },
}

export default defineBlock("guests/featured-guests", (props) => {
  const entries =
    props.guests?.filter((entry) => {
      if (entry?.guest) return true
      return false
    }) || []

  const timer = useSlideTimer({ total: entries.length, slideDuration: 6, enabled: !env.admin })
  const entry = entries[timer.current]

  const films = entry?.guest?.films

  if (!entries.length && env.admin) {
    return (
      <div className="w-grid mx-auto">
        <AdminMessage>No featured guests have been chosen.</AdminMessage>
      </div>
    )
  }
  return (
    <div
      className="block w-grid mx-auto group/featured-guests"
      data-mixpanel-block="Featured Guest"
      data-mixpanel-strand={entry?.guest?.title}
    >
      <LargeCard
        widget={timer.total > 1 && <SlideTimerIndicator timer={timer} />}
        theme="orange"
        title={<div className="type-title-l">{entry?.guest?.title}</div>}
        description={
          <div>
            <EditableText store={"description_" + entry?.guest?.id} defaultValue={entry?.guest?.guestInfo?.bio} />
            <div className="mt-2 text-right md:hidden">
              <Link
                className="basic-link"
                href={`/program/guests/#${entry?.guest?.slug}`}
                onClick={() => {
                  timer.pause()
                }}
              >
                Read More
              </Link>
            </div>
          </div>
        }
        media={
          <Link
            href={`/program/guests/#${entry?.guest?.slug}`}
            onClick={() => {
              timer.pause()
            }}
            className="max-md:aspect-[4/3] bg-black  md:absolute md:inset-0"
          >
            <ResponsiveImage
              max
              objectFit="cover"
              objectPosition="center"
              {...(entry?.imageOverride ?? entry?.guest?.guestInfo?.headshot)}
            />
            <div className="hidden md:flex items-center justify-center absolute inset-0 opacity-0 group-hover/featured-guests:opacity-100 transition-opacity pointer-events-none">
              <Button variant="default">Read more</Button>
            </div>
          </Link>
        }
        animationKey={entry?.guest?.id}
        layout="auto"
        infoWidth="sm"
        height="lg"
        tags={[
          entry?.guest?.guestInfo?.role ? <Chip>{entry?.guest?.guestInfo?.role}</Chip> : null,
          <EditableText
            store={"extraBadge_" + entry?.guest?.id}
            placeholder="Optional extra badge"
            plainText
            as="span"
            className={chipStyles().base()}
          />,
        ]}
      />
    </div>
  )
})
